import Approver from './Approver/Approver';
// import Approver from './Approver/Approver-old';
import DelegateArea from './components/DelegateArea';

function AppApprover() {
    return (
        <>
            <Approver />
            <DelegateArea />
        </>
    );
}

export default AppApprover;
